var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDashboardi = function SvgDashboardi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12.795 21a.753.753 0 0 1-.795-.712v-7.577a.756.756 0 0 1 .795-.712h7.412a.76.76 0 0 1 .793.712v7.577a.755.755 0 0 1-.793.712zm.707-1.5h6v-6h-6zM3.707 21A.693.693 0 0 1 3 20.317v-3.636a.693.693 0 0 1 .707-.683h6.59a.69.69 0 0 1 .7.683v3.636a.69.69 0 0 1-.7.683zm.795-1.5h5v-2h-5zM3.707 15A.75.75 0 0 1 3 14.216V3.783a.75.75 0 0 1 .707-.784h6.59a.75.75 0 0 1 .7.784v10.433a.75.75 0 0 1-.7.784zm.795-1.5h5v-9h-5zm8.293-2.5a.8.8 0 0 1-.795-.8V3.8a.8.8 0 0 1 .795-.8h7.412a.8.8 0 0 1 .793.8v6.4a.8.8 0 0 1-.793.8zm.707-1.5h6v-5h-6z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDashboardi);
export default ForwardRef;